import { render, staticRenderFns } from "./AnalyticsTopCustomers.vue?vue&type=template&id=182dc126"
import script from "./AnalyticsTopCustomers.vue?vue&type=script&lang=js"
export * from "./AnalyticsTopCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports